interface FeatureAnnouncementConfig {
	/**
	 * Displayed in the announcement list popover.
	 */
	title: string;
	/**
	 * Displayed date of the announcement in the announcement list popover.
	 */
	addedDateTsMillis: number;
	/**
	 * The date until which the announcement should be visible.
	 * If not provided, it will remain visible until manually removed from the codebase
	 * or it is no longer within the range of the 5 most recent announcements.
	 */
	endDateTsMillis?: number;
	/**
	 * The "current" announcement is the most recent announcement. Use this flag
	 * for "current"-specific logic (e.g. adding a "New" badge).
	 */
	isCurrent?: boolean;
}

const FEATURE_ANNOUNCEMENT_CONFIGS: Record<string, FeatureAnnouncementConfig> =
	{
		// perMarketLeverage: {
		// 	title: 'Custom Leverage Per Market',
		// 	addedDateTsMillis: 1761868800000,
		// },
		// driftV3: {
		// 	title: 'Velocity v3',
		// 	addedDateTsMillis: 1764806400000,
		// },
		// privyAutoSigning: {
		// 	title: 'Auto-Signing',
		// 	addedDateTsMillis: 1765181900000,
		// 	isCurrent: true,
		// },
	} as const satisfies Record<string, FeatureAnnouncementConfig>;

export type FeatureAnnouncementName = keyof typeof FEATURE_ANNOUNCEMENT_CONFIGS;

export interface FeatureAnnouncement extends FeatureAnnouncementConfig {
	name: FeatureAnnouncementName;
}

export const FEATURE_ANNOUNCEMENTS: Record<
	FeatureAnnouncementName,
	FeatureAnnouncement
> = Object.fromEntries(
	Object.entries(FEATURE_ANNOUNCEMENT_CONFIGS).map(([name, cfg]) => [
		name,
		{ name: name as FeatureAnnouncementName, ...cfg },
	])
) as Record<FeatureAnnouncementName, FeatureAnnouncement>;
